const FALLBACK_APPLE_CLIENT_ID = "com.olitask.dev.web";

export const getAppleClientId = () =>
  process.env.REACT_APP_APPLE_CLIENT_ID || FALLBACK_APPLE_CLIENT_ID;

const normalizeAppleRedirectUri = (redirectUri) => {
  if (!redirectUri) return redirectUri;

  try {
    const parsed = new URL(redirectUri);
    if (parsed.pathname === "/auth/login") {
      parsed.pathname = "/login";
      parsed.search = "";
      parsed.hash = "";
      return parsed.toString();
    }
  } catch {
    return redirectUri;
  }

  return redirectUri;
};

export const getAppleRedirectUri = () => {
  const configuredUri = process.env.REACT_APP_APPLE_REDIRECT_URI;

  if (configuredUri) {
    return normalizeAppleRedirectUri(configuredUri);
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return normalizeAppleRedirectUri(`${window.location.origin}/login`);
  }

  return normalizeAppleRedirectUri("https://dev.olitask.com/login");
};

export const assertAppleRedirectUri = (redirectUri) => {
  if (!redirectUri) {
    throw new Error("Apple redirect URI is not configured.");
  }

  if (!/^https:\/\//i.test(redirectUri)) {
    throw new Error(
      `Apple redirect URI must use HTTPS for the web app. Received: ${redirectUri}`,
    );
  }

  return redirectUri;
};
